import { Reveal } from "../site/Motion";

export const STEPS = [
  ["Share your requirements", "Tell us the division, asset type, budget, condition and timeline. Every field is optional, so start with what you know."],
  ["We search relevant channels", "We look through current listings, relevant channels and our business relationships for assets that fit your needs."],
  ["Review clear information", "We present options with the details available: specifications, condition, location, availability and listing status."],
  ["Stay informed to the finish", "We keep you updated through negotiation and purchase, with clear expectations at each step."],
];

export const Steps = ({ light = false }) => (
  <div className="grid md:grid-cols-2 lg:grid-cols-4 border-t hairline" data-testid="how-it-works-steps">
    {STEPS.map(([t, d], i) => (
      <Reveal key={t} delay={i * 0.1} className={`relative py-10 lg:pr-8 ${i ? "lg:pl-8 lg:border-l hairline" : ""} border-b lg:border-b-0 hairline group`}>
        <span className="font-display italic text-7xl text-transparent [-webkit-text-stroke:1px_rgba(212,175,55,0.7)] transition-colors duration-500 group-hover:text-[var(--gold)]">0{i + 1}</span>
        <h3 className={`font-display text-2xl mt-6 ${light ? "" : "text-slate-50"}`}>{t}</h3>
        <p className="text-sm text-slate-300 mt-3 leading-relaxed">{d}</p>
      </Reveal>
    ))}
  </div>
);
